export function peerReviewText(reviewed: boolean = false) {
  return reviewed ? "PEER REVIEWED" : "IKKE PEER REVIEWED";
}
export function evidenceText(evidence_level: number = 1) {
  if (evidence_level > 4) {
    return "Studiet giver stærk evidens";
  }
  if (evidence_level > 1) {
    return "Studiet giver en vis evidens";
  }
  return "Studiet giver svag evidens";
}

export function getYear(timeString: string | undefined) {
  if (!timeString) return;
  const date = new Date(timeString);

  if (date.toString() === 'Invalid Date') {
    return timeString;
  }

  return date.getFullYear().toString();
}
